import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const HierarchyAdjustments = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        {t('hierarchy.title', 'Hierarchy Adjustments')}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
        {t('hierarchy.subtitle', 'Submit hierarchy adjustment requests using the form below.')}
      </Typography>

      <Box
        sx={{
          borderRadius: 2,
          overflow: 'hidden',
          bgcolor: 'background.paper',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          height: 'calc(100vh - 220px)',
          minHeight: 500,
        }}
      >
        <iframe
          src="https://form.typeform.com/to/zLXdOQsV"
          title="Hierarchy Adjustments Form"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          allow="camera; microphone; autoplay; encrypted-media;"
        />
      </Box>
    </Container>
  );
};

export default HierarchyAdjustments;
